import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=057bb91e&scoped=true&"
import script from "./order-card.vue?vue&type=script&lang=js&"
export * from "./order-card.vue?vue&type=script&lang=js&"
import style0 from "./order-card.vue?vue&type=style&index=0&id=057bb91e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057bb91e",
  null
  
)

export default component.exports